import {AfterViewInit, Component, ElementRef, Input} from '@angular/core';
export class CbjAnimInViewComponent implements AfterViewInit {
  classes: string;
  visible = false;
  setClasses: {};
constructor() { }
/**
 * @return {?}
 */
ngAfterViewInit(): void {
    this.setClass();
  }
/**
 * @param {?} el
 * @return {?}
 */
show(el: ElementRef) {
    this.visible = true;
  }
/**
 * @return {?}
 */
setClass() {
    this.setClasses = {
      'animated': this.visible,
      [this.classes]: this.visible,
      'invisible': !this.visible
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cbj-anim-in-view',
  template: '<div cbjInView (show)="show($event)" [ngClass]="setClasses"><ng-content></ng-content></div>'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'classes': [{ type: Input, args: ['classes', ] },],
};
}

function CbjAnimInViewComponent_tsickle_Closure_declarations() {
/** @type {?} */
CbjAnimInViewComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjAnimInViewComponent.ctorParameters;
/** @type {?} */
CbjAnimInViewComponent.propDecorators;
/** @type {?} */
CbjAnimInViewComponent.prototype.classes;
/** @type {?} */
CbjAnimInViewComponent.prototype.visible;
/** @type {?} */
CbjAnimInViewComponent.prototype.setClasses;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
